import React from "react";
import Loading from "../Loading";
import "./ButtonElement.css";

interface ButtonElementProps {
  buttonText?: string;
  light?: boolean;
  fullWidthSm?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  spinWhenDisabled?: boolean;
}

const ButtonElement: React.FC<ButtonElementProps> = (props) => {
  let classes = "btn";

  if (props.light) {
    classes = classes + " btn-light btn-grey";
  } else {
    classes = classes + " btn-danger btn-orange";
  }

  if (props.fullWidthSm) {
    classes = classes + " full-width-sm";
  }

  const btnProps = {
    onClick: props.onClick,
    disabled: props.disabled,
    type: props.type,
  };

  const spinWhenDisabled = props.spinWhenDisabled;

  return (
    <button className={classes} {...btnProps}>
      {props.disabled && !spinWhenDisabled ? (
        <Loading size="small" />
      ) : props.buttonText ? (
        props.buttonText
      ) : (
        "Trimite"
      )}
    </button>
  );
};

export default ButtonElement;
